import { AddIcon, DownArrow, UpArrow } from 'assests/GmsIcons';
import React, { useEffect, useState } from 'react';
import { CATEGORY_NAME, CREATE_CATEGORY, PRODUCT_CATEGORY, SUB_MODEL, FIELD, CONNECTOR, CONNECTOR_NAME, CREATE_CONNECTOR } from 'Pages/GMS/ISR/ISRConstants';
import DeleteDataModel from './DeleteDataModel';
import CreateFieldDialog from 'Pages/GMS/ISR/Components/CreateFieldDialog';
import { TConnector, TField, TIndexState, TProductCategory, TSubmodel, TUpsertISRProjectDataModelsInput, TTransformation } from '../model';
import FieldItem from './FieldItem';
import CreateISRDialog from 'Pages/GMS/ISR/Components/CreateISRDialog';
import ProductCategoryItem from './ProductCategoryItem';
import { useISRContext } from 'Pages/GMS/ISR/Hooks/useISRContext';
import ConfirmDialog from "../../../Components/ConfirmDialog";

type TSubModelProps = {
    id: string;
    submodel: TSubmodel;
    searchInput: string;
    isSelected: boolean;
    classColor?: string;
    collapseAll: boolean;
    onSelect: () => void;
    submodelIndex: number;
    indexInfo: TIndexState;
    highlightedName?: React.ReactNode;
    onDeleteSubmodel: (submodelName: string|null|undefined) => void;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    setIndex: React.Dispatch<React.SetStateAction<TIndexState>>;
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null ;
    setSelectedItem: React.Dispatch<React.SetStateAction<TField | TSubmodel | TProductCategory | TConnector | null >>;
    setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
    setSubSelectedItem: React.Dispatch<React.SetStateAction<TTransformation | null >>;
}

const SubModelItem = ({id, searchInput, submodel, onDeleteSubmodel, selectedItem, setSubSelectedItem, setIndex, submodelIndex, setSelectedItem, setUserProjectDataModels, isSelected, onSelect, userProjectDataModels, indexInfo, highlightedName, classColor, collapseAll}: TSubModelProps) => {
    const isrContext = useISRContext();
    const [collapse, setCollapse] = useState(false);
    const [showCategoryDialog, setShowCategoryDialog] = useState<boolean>(false);
    const [showConnectorDialog, setShowConnectorDialog] = useState<boolean>(false);
    const [showFieldDialog, setShowFieldDialog] = useState<boolean>(false);
    const [deleteFieldId, setDeleteFieldId] = useState<string|null|undefined>(null);
    const openCategoryDialog = () => setShowCategoryDialog(true);
    const closeCategoryDialog = () => setShowCategoryDialog(false);

    const openFieldDialog = () => setShowFieldDialog(true);
    const closeFieldDialog = () => setShowFieldDialog(false);

    const openConnectorDialog = () => setShowConnectorDialog(true);
    const closeConnectorDialog = () => setShowConnectorDialog(false);

    useEffect(() => {
        setCollapse(collapseAll);
    }, [collapseAll]);

    const handleCollapse = () => {
        setCollapse((prev) => prev = !prev);
    }

    const handleContextMenuOptionClick = () => {
        onDeleteSubmodel(submodel?.id);
    };

    const onFieldSubmit = (fieldName: string, fieldType: string, calculated: boolean, filter: boolean) => {
        isrContext?.setUpdateLocalState(true);
        const newField: TField = { type: fieldType, name: fieldName, belongsToDataModel: true,  dataConfiguration: {enableCalculation: calculated, filterAvailable: filter, minQuantity: 0, maxQuantity: 1, minCount: 0, maxCount: 1}, additionalData: {}, rules: [], };
        updateSubmodelFields(newField);
    };

    const onCategoryFieldSubmit = (fieldName: string) => {
        isrContext?.setUpdateLocalState(true);
        const newField: TProductCategory = { type: 'Category', data: {type: 'Category', name: fieldName, belongsToDataModel: true ,  categories: {type: '', data: []}, transformations:[], compatioScore:false, required: false, minQuantity: 0, maxQuantity: 1, minCount: 0, maxCount: 1} };
        addCategory(newField);
    };

    const onConnectorFieldSubmit = (fieldName: string) => {
        isrContext?.setUpdateLocalState(true);
        const newField: TConnector = { type: "Connector", data: {type: "Connector", isConsumable: true, name: fieldName, belongsToDataModel: true ,  submodels: []} };
        addConnector(newField);
    };

    const addConnector = (connector: TConnector) => {
        setUserProjectDataModels((prevProjectData) => {
            const updatedDataModels = prevProjectData?.project?.dataModels.map((dataModel) => {
                if (dataModel?.data?.name === submodel?.data?.name) {
                    return {...dataModel, data: {...dataModel?.data, connectors: [...dataModel?.data?.connectors ?? [], connector],},};
                }
                return dataModel;
            });
            return {
                ...prevProjectData,
                project: {...prevProjectData?.project, dataModels: updatedDataModels,},
            }
        })
    }


    const addCategory = (newField: TProductCategory) => {
        setUserProjectDataModels((prevProjectData) => {
            const updatedDataModels = prevProjectData.project.dataModels.map((dataModel) => {
                if (dataModel.data.name === submodel?.data?.name) {
                    return { ...dataModel, data: { ...dataModel.data, productCategories: [...dataModel.data.productCategories, newField], }, };
                }
                return dataModel;
            });

            return {
                ...prevProjectData,
                project: { ...prevProjectData.project, dataModels: updatedDataModels, },
            };
        });
    };

    const updateSubmodelFields = (newField: TField) => {
        setUserProjectDataModels((prevProjectData) => {
            const updatedDataModels = prevProjectData.project.dataModels.map((dataModel) => {
                if (dataModel.data.name === submodel?.data?.name) {
                    return { ...dataModel, data: { ...dataModel.data, fields: [...dataModel.data.fields, newField], }, };
                }
                return dataModel;
            });

            return {
                ...prevProjectData,
                project: { ...prevProjectData.project, dataModels: updatedDataModels, },
            };
        });
    };

    const deleteSubmodelFields = (fieldId: string|null|undefined) => {
        setSelectedItem(null);
        setUserProjectDataModels((prevProjectData) => {
            const updatedDataModels = prevProjectData.project.dataModels.map((dataModel) => {
                if (dataModel.data.name === submodel?.data?.name) {
                    const updatedFields = dataModel.data.fields.filter((field) => field?.id !== fieldId);
                    return {...dataModel, data: { ...dataModel.data, fields: updatedFields, }, };
                }
                return dataModel;
            });
    
            return { ...prevProjectData, project: { ...prevProjectData.project, dataModels: updatedDataModels, }, };
        });
        isrContext?.setFieldDelete(isrContext?.fieldDelete.filter((e:string) => e !== fieldId).concat([fieldId]));
    };

    const deleteSubmodelConnectors = (fieldId: string|null|undefined) => {
        setSelectedItem(null);
        setUserProjectDataModels((prevProjectData) => {
            const updatedDataModels = prevProjectData.project.dataModels.map((dataModel) => {
                if (dataModel.data.name === submodel?.data?.name) {
                    const updatedFields = dataModel.data.connectors.filter((field) => field?.id !== fieldId);
                    return {...dataModel, data: { ...dataModel.data, connectors: updatedFields, }, };
                }
                return dataModel;
            });
            return { ...prevProjectData, project: { ...prevProjectData.project, dataModels: updatedDataModels, }, };
        });
    };

    const deleteSubmodelCategories = (fieldId: string|null|undefined) => {
        setSelectedItem(null);
        setUserProjectDataModels((prevProjectData) => {
            const updatedDataModels = prevProjectData.project.dataModels.map((dataModel) => {
                if (dataModel.data.name === submodel?.data?.name) {
                    const updatedFields = dataModel.data.productCategories.filter((field) => field?.id !== fieldId);
                    return {...dataModel, data: { ...dataModel.data, productCategories: updatedFields, }, };
                }
                return dataModel;
            });
    
            return { ...prevProjectData, project: { ...prevProjectData.project, dataModels: updatedDataModels, }, };
        });
    };

    const deleteSubmodelTransformations = (categoryId: string, transformationId: string) => {
        setUserProjectDataModels((prevProjectData) => {
            const updatedDataModels = prevProjectData.project.dataModels.map((dataModel) => {

                if (dataModel.data.name === submodel?.data?.name) {
                    const updatedFields = dataModel.data.productCategories.map(
                        (category) => {
                            if (category.id === categoryId) {
                                category.data.transformations = category?.data?.transformations?.filter(
                                    transformation =>
                                        transformation.id !== transformationId)
                            }
                            return category
                        }
                    );
                    return { ...dataModel, data: { ...dataModel.data, productCategories: updatedFields, }, };
                }
                return dataModel;
            });
            


            return { ...prevProjectData, project: { ...prevProjectData.project, dataModels: updatedDataModels, }, };
        });
    };

    const handleFieldSelect = (dataModelIndex: number, fieldIndex: number) => {
        setIndex({ dataModelIndex, fieldIndex, fieldOutsideDataModelIndex: null });
    };

    const handleCategorySelect = (dataModelIndex: number, categoryIndex: number) => {
        setIndex({ dataModelIndex, fieldIndex: null, categoryIndex: categoryIndex , fieldOutsideDataModelIndex: null });
    };

    const handleConnectorSelect = (dataModelIndex: number, connectorIndex: number) => {
        setIndex({ dataModelIndex, fieldIndex: null, categoryIndex: null, connectorIndex: connectorIndex, fieldOutsideDataModelIndex: null });
    };

    return (
        <React.Fragment key={submodel?.data?.name + submodel?.type}>
            <div id={id} className='tw-rounded tw-bg-[#f9fbfe] tw-box-border tw-w-full tw-h-auto tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 tw-mt-3'>
                <div id={`${id}-header`} onClick={onSelect} className={`tw-rounded tw-cursor-pointer tw-bg-shades-of-grey-0 tw-box-border tw-w-full tw-h-auto tw-flex tw-flex-row tw-items-center tw-justify-between tw-gap-[12px] tw-border-[1px] tw-border-solid ${isSelected ? 'tw-border-primary tw-text-primary' : 'tw-border-shades-of-grey-30 tw-text-shades-of-grey-60'}`}>
                    <div id={`${id}-title-section`} className='tw-flex tw-justify-start tw-items-center'>
                        {classColor ? <div id={`${id}-color-bar`} style={{backgroundColor: classColor}} className="tw-w-[5px] tw-h-[42px] tw-bg-slate-600 tw-rounded-tl-[3px] tw-rounded-bl-[3px]" /> : null}
                        <div id={`${id}-labels`} className='tw-py-[3px] tw-px-3'>
                            {highlightedName ? 
                                <label id={`${id}-name-highlighted`} className='tw-text-xs tw-block'>{highlightedName}</label> :
                                <label id={`${id}-name`} className='tw-text-xs tw-block'>{submodel?.data?.name ?? ""}</label>
                            }
                            <label id={`${id}-type`} className='tw-text-xs tw-text-[#747593] tw-block'>{SUB_MODEL}</label>
                        </div>
                    </div>
                    <div id={`${id}-actions`} className='tw-flex tw-items-center tw-px-3'>
                        <div id={`${id}-delete-menu`} onClick={(e) => { e.stopPropagation();}}><DeleteDataModel onContextMenuOptionClick={handleContextMenuOptionClick}/></div>
                        <button 
                            id={`${id}-collapse-btn`}
                            onClick={(e) => { e.stopPropagation(); handleCollapse(); }} 
                            className='tw-rounded tw-bg-gainsboro-100 tw-w-6 tw-h-6 tw-flex tw-flex-col tw-items-center tw-justify-center'
                        >
                            {!collapse ? <UpArrow /> : <DownArrow />}
                        </button>
                    </div>
                </div>
                
                {!collapse ? 
                    <div id={`${id}-fields-section`}>
                        {submodel?.data?.fields.length > 0 ? submodel.data.fields.map((field, fieldIndex) => {
                            const show = searchInput ? submodel.data.name.toLowerCase().includes(searchInput.toLowerCase()) || field.name.toLowerCase().includes(searchInput?.toLowerCase()) : true;
                            if(!show) {
                                return <></>;
                            }
                            return <div id={`${id}-field-${fieldIndex}`} key={field.name + field.type + fieldIndex} className='tw-mx-2 tw-my-2'>

                                <FieldItem
                                    id={`${id}-field-item-${fieldIndex}`}
                                    fieldName={field.name}
                                    fieldId={field?.id}
                                    fieldType={field.type}
                                    showCalculatedField={field?.dataConfiguration?.enableCalculation}
                                    selectedItem={selectedItem}
                                    classColor={field?.dataConfiguration?.class?.colour}
                                    indexInfo={indexInfo}
                                    userProjectDataModels={userProjectDataModels}
                                    onDelete={(fieldId) => setDeleteFieldId(fieldId)}
                                    onSelect={() => {
                                        handleFieldSelect(submodelIndex, fieldIndex);
                                        const selectedField = userProjectDataModels.project.dataModels[submodelIndex].data.fields[fieldIndex];
                                        setSelectedItem(selectedField);
                                        setSubSelectedItem(null)
                                    }}
                                    isSelected={field === selectedItem}
                                />
                            </div>;
                        }) : null}
                    </div>
                : null}

                {!collapse ? 
                    <div id={`${id}-categories-section`}>
                        {submodel?.data?.productCategories.length > 0 ? submodel.data.productCategories.map((category, fieldIndex) => {
                            const show = searchInput ? submodel.data.name.toLowerCase().includes(searchInput.toLowerCase()) || category?.data?.name.toLowerCase().includes(searchInput?.toLowerCase()) : true;
                            if(!show) {
                                return <></>;
                            }
                            return <div id={`${id}-category-${fieldIndex}`} key={category?.data?.name + category?.type} className='tw-mx-2 tw-my-2'>
                                <ProductCategoryItem
                                    id={`${id}-category-item-${fieldIndex}`}
                                    field={category}
                                    fieldName={category?.data?.name}
                                    fieldType={category.type}
                                    indexInfo={indexInfo}
                                    userProjectDataModels={userProjectDataModels}
                                    onDelete={deleteSubmodelCategories}
                                    selectedItem={selectedItem}
                                    onSelect={() => {
                                        handleCategorySelect(submodelIndex, fieldIndex);
                                        setSelectedItem(category);
                                        setSubSelectedItem(null)
                                    }}
                                    isSelected={category === selectedItem}
                                    setIndex={setIndex}
                                    setSubSelectedItem={setSubSelectedItem}
                                    setUserProjectDataModels={setUserProjectDataModels}
                                    onSubDelete={deleteSubmodelTransformations}
                                />
                            </div>;
                        }) : null}
                    </div>
                : null}

                {!collapse ? 
                    <div id={`${id}-connectors-section`}>
                        {submodel?.data?.connectors && submodel?.data?.connectors.length > 0 ? submodel.data.connectors.map((connector, connectorIndex) => {
                            const show = searchInput ? submodel.data.name.toLowerCase().includes(searchInput.toLowerCase()) || connector?.data?.name.toLowerCase().includes(searchInput?.toLowerCase()) : true;
                            if(!show) {
                                return <></>;
                            }
                            return <div id={`${id}-connector-${connectorIndex}`} key={connector?.data?.name + connector?.type} className='tw-mx-2 tw-my-2'>
                                <FieldItem
                                    id={`${id}-connector-item-${connectorIndex}`}
                                    fieldName={connector?.data?.name}
                                    fieldId={connector?.id}
                                    fieldType={connector.type}
                                    indexInfo={indexInfo}
                                    userProjectDataModels={userProjectDataModels}
                                    onDelete={deleteSubmodelConnectors}
                                    selectedItem={selectedItem}
                                    onSelect={() => {
                                        handleConnectorSelect(submodelIndex, connectorIndex);
                                        setSelectedItem(connector);
                                        setSubSelectedItem(null)
                                    }}
                                    isSelected={connector === selectedItem}
                                />
                            </div>;
                        }) : null}
                    </div>
                : null}     
            
                {!collapse ? 
                    <div id={`${id}-add-buttons`} className='tw-flex tw-flex-wrap tw-items-center tw-gap-1.5 tw-py-2 tw-px-2'>
                        <button 
                            id={`${id}-add-field-btn`}
                            onClick={openFieldDialog} 
                            className='tw-rounded tw-bg-shades-of-grey-0 tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-6 tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm tw-text-primary tw-border-[1px] tw-border-solid tw-border-primary active:tw-scale-95'
                        >
                            <AddIcon color='#0747A6'/>
                            {FIELD}
                        </button>
                        <button 
                            id={`${id}-add-category-btn`}
                            onClick={openCategoryDialog} 
                            className='tw-rounded tw-bg-shades-of-grey-0 tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-6 tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm tw-text-primary tw-border-[1px] tw-border-solid tw-border-primary active:tw-scale-95'
                        >
                            <AddIcon color="#0747A6"/>
                            {PRODUCT_CATEGORY}
                        </button>
                        <button 
                            id={`${id}-add-connector-btn`}
                            onClick={openConnectorDialog} 
                            className='tw-rounded tw-bg-shades-of-grey-0 tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-6 tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm tw-text-primary tw-border-[1px] tw-border-solid tw-border-primary active:tw-scale-95'
                        >
                            <AddIcon color="#0747A6"/>
                            {CONNECTOR}
                        </button>
                    </div> 
                : null}
            </div>
            {showFieldDialog ? 
                <CreateFieldDialog 
                    id={`${id}-field-dialog`}
                    onClose={closeFieldDialog} 
                    onFieldSubmit={onFieldSubmit} 
                /> : null}
            {showCategoryDialog ? 
                <CreateISRDialog 
                    id={`${id}-category-dialog`}
                    dialogHeader={CREATE_CATEGORY} 
                    labelName={CATEGORY_NAME} 
                    onClose={closeCategoryDialog} 
                    onSubmodelFieldSubmit={onCategoryFieldSubmit} 
                /> : null}  
            {showConnectorDialog ? 
                <CreateISRDialog 
                    id={`${id}-connector-dialog`}
                    dialogHeader={CREATE_CONNECTOR} 
                    labelName={CONNECTOR_NAME} 
                    onClose={closeConnectorDialog} 
                    onSubmodelFieldSubmit={onConnectorFieldSubmit} 
                /> : null}  
            {deleteFieldId != null ? 
                <ConfirmDialog 
                    id={`${id}-delete-confirm-dialog`}
                    title={'Delete field'}
                    message={'This field may have other dependencies , are you sure you want to continue ?'}
                    onClose={() => {
                        setDeleteFieldId(null);
                    }} 
                    onConfirm={() => {
                        deleteSubmodelFields(deleteFieldId)
                        setDeleteFieldId(null);
                    }}
                /> : null}
        </React.Fragment>
    );
}

export default SubModelItem;